<app-shared-dialog
  [title]="'quotations_and_orders.enrich_external_references.title' | translate"
  [options]="{
    size: 'medium',
    confirmText: 'quotations_and_orders.enrich_external_references.apply' | translate,
    confirmButtonStyle: 'primary',
    cancelText: 'quotations_and_orders.enrich_external_references.ignore' | translate,
    cancelButtonStyle: 'secondary',
    confirmLoading: isSaving,
    confirmDisabled: isSaving || enabledCount === 0
  }"
  (confirm)="apply()"
  (cancel)="close()">

  <div class="enrich-references">
    <p class="enrich-references__eyebrow">
      {{ 'quotations_and_orders.enrich_external_references.suggested_rule' | translate }}
    </p>

    <p class="enrich-references__description">
      {{ 'quotations_and_orders.enrich_external_references.header_desc' | translate: { company: data?.companyName } }}
    </p>

    <div class="enrich-references__list">
      <div class="enrich-references__row" *ngFor="let row of rows">
        <span class="enrich-references__text">
          {{ 'quotations_and_orders.enrich_external_references.row_desc' | translate: { code: row.code, sku: row.sku } }}
        </span>
        <span class="enrich-references__already-saved" *ngIf="row.alreadySaved">
          {{ 'quotations_and_orders.enrich_external_references.already_saved' | translate }}
        </span>
        <mat-slide-toggle
          [(ngModel)]="row.enabled"
          color="primary"
          [disabled]="isSaving || row.alreadySaved">
        </mat-slide-toggle>
      </div>
    </div>

    <p class="enrich-references__disclaimer">
      {{ 'quotations_and_orders.enrich_external_references.helper' | translate }}
    </p>
  </div>
</app-shared-dialog>
